import type { FC } from 'react'
import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { DominosMonoLogo } from '@segment/matcha/components/CompanyLogos/CompanyMono'

import TestimonialBase, * as Testimonial from '@segment/matcha/recipes/Testimonial'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  description: `“Having Segment has not only helped us to do the personalization work we’ve always wanted to do, but we can now improve on the effectiveness of our ad campaigns and drive that feedback loop.”`,
  author: `Christian Rocha Castillo`,
  role: `Deputy Director Ecommerce/Digital Media`,
}

const TestimonialComponent: FC = () => {
  const theme = useTheme()
  return (
    <StyledSectionBase variant="centered">
      <Section.Contents>
        <TestimonialBase variant="base">
          <Testimonial.Base height="auto">
            <Testimonial.BaseContentSlot>
              <Testimonial.BaseLogo>
                <DominosMonoLogo color={`${theme.palette.neutrals.white[`100`]}`} />
              </Testimonial.BaseLogo>
              <Testimonial.BaseText>{copy.description}</Testimonial.BaseText>
            </Testimonial.BaseContentSlot>
            <Testimonial.BaseAuthorSlot>
              <Testimonial.AuthorInfo>
                <Testimonial.AuthorName>{copy.author}</Testimonial.AuthorName>
                <Testimonial.AuthorPosition>{copy.role}</Testimonial.AuthorPosition>
              </Testimonial.AuthorInfo>
            </Testimonial.BaseAuthorSlot>
          </Testimonial.Base>
        </TestimonialBase>
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 0;
    ${Section.Contents} {
      max-width: 900px;
    }
  }
`

export default TestimonialComponent
